export default "__VITE_PUBLIC_ASSET__dea2f477__"